import { addCommasToNumber, Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import { useFormatter } from '@api/useFormatter'
import { SimpleRow } from '@components/InventoryValuation/Costing/Details/SimpleRow'
import type { SimpleLayersProps } from './types'

export const SimpleLayers = ({ data, final, openOrderModal, showDate, totalsData }: SimpleLayersProps) => {
  if (!data || !data.length)
    return (
      <Horizontal style={{ width: '100%' }} alignItems={'center'} justifyContent={'center'}>
        <Texto align={'center'} className={'text-size-5 text-gray-500 font-italic'}>
          No {final ? 'Final' : 'Beginning'} Layers
        </Texto>
      </Horizontal>
    )

  const { formatCurrency } = useFormatter()
  const formattedCurrency = formatCurrency(null, true)

  return (
    <div className={'full-height-width'}>
      <Horizontal style={{ width: '100%', minHeight: 'min-content' }}>
        <Vertical className='p-2' flex={1.5} justifyContent={'center'} alignItems={'center'} />
        <Vertical className='p-2' flex={1} justifyContent={'center'} alignItems={'center'}>
          <Texto appearance='medium'>DEL. DATE</Texto>
        </Vertical>
        <Vertical className='p-2' flex={1} justifyContent={'center'} alignItems={'center'}>
          <Texto appearance='medium'>BOL</Texto>
        </Vertical>
        <Vertical className='p-2' flex={1} justifyContent={'center'} alignItems={'center'}>
          <Texto appearance='medium'>ORDER</Texto>
        </Vertical>
        <Vertical className='p-2' flex={1.5} justifyContent={'center'} alignItems={'center'}>
          <Texto appearance='medium'>SUPPLIER</Texto>
        </Vertical>
        <Vertical className='p-2' flex={1} justifyContent={'center'} alignItems={'flex-end'}>
          <Texto appearance='medium'>VOLUME</Texto>
        </Vertical>
        <Vertical className='p-2 ' flex={1} justifyContent={'center'} alignItems={'flex-end'}>
          <Texto appearance='medium'>PRICE</Texto>
        </Vertical>
        <Vertical className='p-2 mr-2' flex={1} justifyContent={'center'} alignItems={'flex-end'}>
          <Texto appearance='medium'>VALUE</Texto>
        </Vertical>
      </Horizontal>
      {data?.map((row, index) => (
        <SimpleRow
          row={row}
          index={index}
          key={final ? `final-${index}` : `beginning-${index}`}
          formattedCurrency={formattedCurrency}
          openOrderModal={openOrderModal}
          showDate={showDate}
          isTemp={row?.is_temporary}
        />
      ))}
      <Horizontal className='bordered bg-1' style={{ width: '100%' }}>
        <Vertical className='p-2' flex={1.5} />
        <Vertical className='p-2' flex={1.5} />
        <Vertical className='p-2' flex={1} />
        <Vertical className='p-2' flex={1} />
        <Vertical className='p-2' flex={1} />
        <Vertical className='p-2' flex={1} alignItems={'flex-end'}>
          <Texto className='text-truncate full-height-width ' align={'right'} weight={'bold'}>
            {addCommasToNumber(totalsData?.volume, 0)}
          </Texto>
        </Vertical>
        <Vertical className='p-2' flex={1} justifyContent={'center'} alignItems={'flex-end'}>
          <Texto className='text-truncate' weight={'bold'} align={'right'} style={{ width: '100%' }}>
            {formattedCurrency}
            {addCommasToNumber(totalsData?.price, 4)}
          </Texto>
        </Vertical>
        <Vertical className='p-2 mr-2' flex={1} alignItems={'flex-end'}>
          <Texto className='text-truncate full-height-width ' align={'right'} weight={'bold'}>
            {formattedCurrency}
            {addCommasToNumber(totalsData?.value, 2)}
          </Texto>
        </Vertical>
      </Horizontal>
    </div>
  )
}
